import { Typography, TypographyProps } from '@mui/material';

const QDrawerError = ({ children, ...props}: TypographyProps) => (
	<Typography px={1} textAlign='left' color={'error'} variant='body1' {...props}>{children}</Typography>
);

export default QDrawerError;
